import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, CheckCircle2, KeyRound, Loader2, LockKeyhole, MailCheck, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const errText = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? "Bilgileri kontrol edin" : "Bağlantı hatası, lütfen tekrar deneyin"; };

export function StepDots({ step }) {
  return <div className="gate-steps" data-testid="gate-steps">{[1, 2, 3].map((i) => <i key={i} className={i < step ? "done" : i === step ? "on" : ""} />)}<small data-testid="gate-step-label">Adım {step} / 3</small></div>;
}

function GateVisual() {
  return (
    <section className="login-visual"><div className="visual-copy">
      <span className="gate-visual-icon"><ShieldCheck size={26} /></span><span className="eyebrow">KORUMALI ALAN</span>
      <h1>Üç adımlı güvenli giriş.</h1><p>Yönetim paneline yalnızca iki güvenlik şifresini ve hesap bilgilerini bilen yetkililer ulaşabilir.</p>
    </div></section>
  );
}

function Forgot() {
  const [state, setState] = useState(null), [busy, setBusy] = useState(false);
  const send = async () => { setBusy(true); try { const r = await axios.post(`${API}/auth/gate/forgot`); setState({ ok: r.data.email }); } catch (e) { setState({ err: errText(e) }); } setBusy(false); };
  if (state?.ok) return <p className="gate-note ok" data-testid="gate-forgot-sent"><MailCheck size={15} />Yenileme bağlantısı {state.ok} adresine gönderildi. Bağlantı 1 saat geçerlidir.</p>;
  return <>{state?.err && <p className="gate-note err" data-testid="gate-forgot-error">{state.err}</p>}<button type="button" className="text-btn" onClick={send} disabled={busy} data-testid="gate-forgot-btn">{busy ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />}Güvenlik şifrelerimi unuttum</button></>;
}

const COPY = { 1: ["Güvenlik şifresi", "Devam etmek için birinci güvenlik şifresini girin."], 2: ["İkinci güvenlik şifresi", "Şimdi ikinci güvenlik şifresini girin."] };

export function AdminGate({ brand, onPass }) {
  const [step, setStep] = useState(1), [pw, setPw] = useState(""), [token, setToken] = useState(""), [error, setError] = useState(""), [busy, setBusy] = useState(false);
  const restart = () => { setStep(1); setToken(""); setPw(""); };
  const submit = async (e) => {
    e.preventDefault(); setError(""); setBusy(true);
    try { const r = await axios.post(`${API}/auth/gate`, { step, password: pw, token }); setPw(""); if (step === 1) { setToken(r.data.token); setStep(2); } else onPass(r.data.token); }
    catch (err) { if (step === 2 && err.response?.status === 401 && /süresi/.test(err.response?.data?.detail || "")) restart(); setError(errText(err)); }
    setBusy(false);
  };
  const [title, sub] = COPY[step];
  return (
    <main className="login-shell" data-testid="admin-gate"><GateVisual />
      <section className="login-form-area"><form className="login-card gate-card" onSubmit={submit}>{brand}<StepDots step={step} />
        <div className="login-heading"><span className="eyebrow">GÜVENLİK ADIMI {step}</span><h2 data-testid="gate-title">{title}</h2><p>{sub}</p></div>
        <label>{step}. güvenlik şifresi<input key={step} type="password" autoFocus autoComplete="off" value={pw} onChange={(e) => setPw(e.target.value)} data-testid={`gate-password-${step}`} /></label>
        {error && <div className="error" data-testid="gate-error">{error}</div>}
        <button className="primary-btn full" disabled={busy || !pw} data-testid="gate-submit">{busy ? <Loader2 size={17} className="animate-spin" /> : <LockKeyhole size={17} />}Devam et</button>
        <div className="gate-foot">{step === 2 && <button type="button" className="text-btn" onClick={() => { restart(); setError(""); }} data-testid="gate-back">Başa dön</button>}<Forgot /></div>
      </form></section>
    </main>
  );
}

export function GateReset({ brand }) {
  const [q] = useSearchParams(), go = useNavigate(), token = q.get("token") || "";
  const [f, setF] = useState({ pw1: "", pw2: "" }), [error, setError] = useState(""), [busy, setBusy] = useState(false), [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (f.pw1.length < 6 || f.pw2.length < 6) return setError("Her iki şifre de en az 6 karakter olmalı");
    if (f.pw1 === f.pw2) return setError("İki şifre birbirinden farklı olmalı");
    setBusy(true);
    try { await axios.post(`${API}/auth/gate/reset`, { token, ...f }); setDone(true); } catch (err) { setError(errText(err)); }
    setBusy(false);
  };
  const input = (k, n) => <label>{n}. güvenlik şifresi<input type="password" autoComplete="new-password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`gate-reset-${k}`} /></label>;
  return (
    <main className="login-shell" data-testid="gate-reset-page"><GateVisual />
      <section className="login-form-area"><form className="login-card gate-card" onSubmit={submit}>{brand}
        <div className="login-heading"><span className="eyebrow">GÜVENLİK ŞİFRELERİ</span><h2>Yeni güvenlik şifreleri</h2><p>Panel girişinde sırayla sorulacak iki şifreyi belirleyin.</p></div>
        {done ? <><p className="gate-note ok" data-testid="gate-reset-done"><CheckCircle2 size={15} />Şifreler güncellendi. Yeni şifrelerle giriş yapabilirsiniz.</p><button type="button" className="primary-btn full" onClick={() => go("/admin", { replace: true })} data-testid="gate-reset-go">Girişe git <ArrowUpRight size={17} /></button></>
          : !token ? <div className="error" data-testid="gate-reset-no-token">Bağlantı eksik. E-postadaki bağlantıya tekrar tıklayın.</div>
          : <>{input("pw1", 1)}{input("pw2", 2)}<small className="form-hint">En az 6 karakter; iki şifre birbirinden farklı olmalı.</small>
            {error && <div className="error" data-testid="gate-reset-error">{error}</div>}
            <button className="primary-btn full" disabled={busy} data-testid="gate-reset-submit">{busy ? <Loader2 size={17} className="animate-spin" /> : <ShieldCheck size={17} />}Şifreleri kaydet</button></>}
      </form></section>
    </main>
  );
}
